import { render, staticRenderFns } from "./setLans.vue?vue&type=template&id=d6445d9e&scoped=true&"
import script from "./setLans.vue?vue&type=script&lang=js&"
export * from "./setLans.vue?vue&type=script&lang=js&"
import style0 from "./setLans.vue?vue&type=style&index=0&id=d6445d9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6445d9e",
  null
  
)

export default component.exports